import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const pricingPlans = [{
  name: 'Professional',
  price: '£99',
  period: 'one-time',
  description: 'Perfect for small teams getting started with Daily Serve',
  features: ['Up to 10 team members', 'Unlimited projects', 'Client portal access', 'Basic integrations', 'Email support', '5GB storage', 'Mobile app access'],
  link: 'https://buy.stripe.com/28EcMXduE6wJg7zbCS6c001',
  highlighted: false
}, {
  name: 'Enterprise',
  price: '£120',
  period: 'one-time',
  description: 'For larger teams with advanced needs and requirements',
  features: ['Unlimited team members', 'Unlimited projects', 'Advanced client portal', 'Premium integrations', 'Priority support', 'Custom workflows', 'Advanced analytics', '50GB storage', 'API access', 'Dedicated account manager'],
  link: 'https://buy.stripe.com/00w00b0HS2gtaNffT86c000',
  highlighted: true
}];
export const Pricing = () => {
  return <div className="bg-white" data-id="element-405">
      <section className="py-16 md:py-24 bg-gradient-to-b from-white to-brand-light" data-id="element-406">
        <div className="container-custom" data-id="element-407">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center max-w-3xl mx-auto" data-id="element-408">
            <h1 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6" data-id="element-409">
              Simple, transparent pricing
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-410">
              Choose the plan that works best for your team. One-time payment,
              lifetime access. No hidden fees.
            </p>
          </motion.div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-411">
        <div className="container-custom" data-id="element-412">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-413">
            {pricingPlans.map((plan, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`rounded-lg p-8 ${plan.highlighted ? 'bg-gradient-to-br from-brand-blue to-brand-teal text-white shadow-xl scale-105' : 'bg-brand-light shadow-sm'}`} data-id="element-414">
                {plan.highlighted && <div className="text-sm font-semibold mb-2 text-white" data-id="element-415">
                    MOST POPULAR
                  </div>}
                <h3 className={`text-2xl font-bold mb-2 ${plan.highlighted ? 'text-white' : 'text-brand-blue'}`} data-id="element-416">
                  {plan.name}
                </h3>
                <div className="mb-4" data-id="element-417">
                  <span className={`text-5xl font-bold ${plan.highlighted ? 'text-white' : 'text-brand-blue'}`} data-id="element-418">
                    {plan.price}
                  </span>
                  <span className={`text-sm ml-2 ${plan.highlighted ? 'text-white' : 'text-gray-600'}`} data-id="element-419">
                    {plan.period}
                  </span>
                </div>
                <p className={`mb-6 ${plan.highlighted ? 'text-white' : 'text-gray-600'}`} data-id="element-420">
                  {plan.description}
                </p>
                <ul className="space-y-3 mb-8" data-id="element-421">
                  {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-422">
                      <CheckIcon className={`h-5 w-5 mr-2 flex-shrink-0 ${plan.highlighted ? 'text-white' : 'text-brand-teal'}`} data-id="element-423" />
                      <span className={`text-sm ${plan.highlighted ? 'text-white' : 'text-gray-700'}`} data-id="element-424">
                        {feature}
                      </span>
                    </li>)}
                </ul>
                <a href={plan.link} target="_blank" rel="noopener noreferrer" className={`block w-full text-center py-3 px-6 rounded-md font-medium transition-all duration-200 ${plan.highlighted ? 'bg-white text-brand-blue hover:bg-opacity-90' : 'bg-brand-teal text-white hover:bg-opacity-90'}`} data-id="element-425">
                  Get started
                </a>
              </motion.div>)}
          </div>
        </div>
      </section>
      <section className="py-16 bg-brand-light" data-id="element-426">
        <div className="container-custom text-center" data-id="element-427">
          <h2 className="text-2xl font-bold text-brand-blue mb-4" data-id="element-428">
            Have questions about pricing?
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-429">
            We're here to help you find the right plan for your team.
          </p>
          <a href="mailto:rapeezshrestha385@gmail.com" className="btn-primary" data-id="element-430">
            Contact us
          </a>
        </div>
      </section>
    </div>;
};